import { combineReducers } from 'redux';
import { AccountTypes } from '../../action_types';
import { arrayToObject, removeItem, insertItem, updateObjectInArray } from 'src/utils/helpers';

function all(state = {}, action) {
  switch (action.type) {
    case AccountTypes.GET_ACCOUNTS_SUCCESS:
      return { ...state, ...arrayToObject(action.data.results) };
    case AccountTypes.UPDATE_ACCOUNT_SUCCESS:
    case AccountTypes.GET_ACCOUNT_SUCCESS:
    case AccountTypes.CHANGE_ROLE_SUCCESS:
      return {
        ...state,
        [action.data.id]: action.data,
      };
    case AccountTypes.DELETE_ACCOUNT_SUCCESS:
      const { [action.id]: _, ...newState } = state;
      return newState;
    default:
      return state;
  }
}

function ui(state = [], action) {
  switch (action.type) {
    case AccountTypes.GET_ACCOUNTS_SUCCESS:
      return action.data.results;
    case AccountTypes.UPDATE_ACCOUNT_SUCCESS:
    case AccountTypes.CHANGE_ROLE_SUCCESS: {
      return updateObjectInArray(state, action.data);
    }
    case AccountTypes.GET_ACCOUNT_SUCCESS:
      return insertItem(state, action.data);
    case AccountTypes.DELETE_ACCOUNT_SUCCESS:
      return removeItem(state, action.id);
    default:
      return state;
  }
}

function meta(state = {}, action) {
  switch (action.type) {
    case AccountTypes.GET_ACCOUNTS_SUCCESS: {
      const { results, ...rest } = action.data;
      return { ...state, ...rest };
    }
    case AccountTypes.GET_ACCOUNT_SUCCESS:
      return { ...state, count: state.count + 1 };
    case AccountTypes.DELETE_ACCOUNT_SUCCESS:
      return { ...state, count: state.count - 1 };
    default:
      return state;
  }
}

function invite(state = {}, action) {
  switch (action.type) {
    case AccountTypes.INVITE_USERS_SUCCESS:
      return action.data;

    default:
      return state;
  }
}

function existed_user(state = false, action) {
  switch (action.type) {
    case AccountTypes.CHECK_ACCOUNT_SUCCESS:
      return action.data?.existed_user;
    default:
      return state;
  }
}

function inviteLink(state = {}, action) {
  switch (action.type) {
    case AccountTypes.GET_INVITE_LINK_SUCCESS:
      return {[action?.username]: action?.data?.invite_link}

    default:
      return state;  
  }
}

function resetPWLink(state = {}, action) {
  switch (action.type) {
    case AccountTypes.GET_RESET_PASSWORD_LINK_SUCCESS:
      return {[action?.username]: action?.data?.reset_link}

    default:
      return state;  
  }
}

export default combineReducers({
  all,
  ui,
  meta,
  invite,
  existed_user,
  inviteLink,
  resetPWLink
});
